// useEmergencyNumber – returns the number the app should actually dial /
// display right now.
//
// Priority:
//   1. `custom.number` from the current QR object (per-location override –
//      set via the "number" key in the object description).
//   2. Global default from i18n (currently hard-coded to 112).
//
// Also exposes `isCustom` so consumers can suppress locale hints (144/999)
// that would be misleading when a bespoke number is in play, and
// `country` (from i18n `emergencyHint`) for those that still want to
// render the hint when appropriate.

import { useI18n } from "./i18n";
import { useQr } from "./qrContext";

export function useEmergencyNumber() {
    const { emergencyNumber, emergencyHint } = useI18n();
    const { custom } = useQr();
    const overridden =
        custom &&
        typeof custom.number === "string" &&
        custom.number.trim().length > 0;
    return {
        number: overridden ? custom.number.trim() : emergencyNumber,
        isCustom: Boolean(overridden),
        emergencyHint: overridden ? "" : emergencyHint,
    };
}
